import styled from 'styled-components';

export const StreamAPIWrapper = styled.div`
.text-align-justify{
    text-align: justify;
}
.entry-title {
    font-weight: 600;
    font-size: 1.9rem;
    text-align: center;
}
.text-align-center{
    text-align: center;
}
p, li {
    color: #334155;
}
p, li {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #334155;
}
.epyt-gallery-subscribe a.epyt-gallery-subbutton, .epyt-gallery-subscribe a.epyt-gallery-subbutton:hover {
    background-color: #e62117 !important;
    border-radius: 3px;
    color: #fff !important;
    display: inline-block;
    padding: 5px 10px;
    text-decoration: none !important;
}
.epyt-gallery-subscribe {
    clear: both;
    padding: 15px 0 10px;
    text-align: center;
}
.epyt-gallery-subscribe a.epyt-gallery-subbutton img {
    background: transparent;
    box-shadow: none;
    display: inline-block;
    height: auto !important;
    margin: 0;
    padding: 0 6px 3px 0;
    vertical-align: middle !important;
    width: 20px !important;
}
.programs{
    background: linear-gradient(274deg, rgb(255 0 0) 0%, rgb(46 68 207) 100%);
    border-style: none;
    margin: 0.5rem;
}
.programs a {
    color: #fff;
    font-weight: 500;
    text-decoration: none;
}
`;
